export * from './Icon';
export * from './Icon.base';
export * from './Icon.types';
export * from './FontIcon';
export * from './ImageIcon';



// WEBPACK FOOTER //
// ../src/components/Icon/index.ts